import React from "react";
import img1 from "../images/Malai.1.png";
import img2 from "../images/Malai.2.png";

const Malai = () => {
  return (
    <div className="flex items-center justify-center gap-7 5xl:gap-24   px-3 py-2  ">
      <div>
        <div className=" block 5xl:hidden text-center">
          <h1 className="text-center mt-10  text-lg md:text-2xl 2xl:text-3xl 4xl:text-4xl 8xl:text-5xl 9xl:text-6xl 10xl:text-7xl 11xl:text-8xl font-semibold  mb-2">
            We Are Selling
          </h1>
          <h2 className="font-abhaya text-md md:text-xl 2xl:text-2xl 8xl:text-3xl text-center font-bold text-secondary">
            PATTU MALAI
          </h2>
        </div>
        <div className="relative">
          <img
  className="5xl:border-2 border-2 rounded-xl 5xl:rounded-none border-primary  5xl:p-4 w-full max-w-[300px] xs:max-w-[350px] sm:max-w-[400px] xl:max-w-[450px] 2xl:max-w-[500px] 4xl:max-w-[550px] h-[200px] sm:h-[250px] xl:h-[350px] 2xl:h-[400px] 5xl:border-secondary object-cover"
  src={img1}
  alt="pattu"
/>

          <div className="absolute bottom-7 left-1/2 transform text-center -translate-x-1/2 bg-[#000] px-4  bg-opacity-5 bg-[linear-gradient(179.61deg,_rgba(255,255,255,0)_-16.76%,_rgba(0,0,0,0.6)_0.33%)] w-full 5xl:w-[180px] 8xl:w-[200px] p-5 py-1 mb-4  text-primary font-bold font-abhaya text-md sm:text-lg  5xl:text-xl 7xl:text-2xl">
            PATTU MALAI
          </div>
        </div>
      </div>
      <div className="">
        <div className="relative">
          <img
  className="5xl:border-2 border-2 rounded-xl 5xl:rounded-none 5xl:mt-20 border-primary  5xl:p-4 w-full  max-w-[300px] xs:max-w-[350px] sm:max-w-[400px] xl:max-w-[450px] 2xl:max-w-[500px] 4xl:max-w-[550px] h-[200px] sm:h-[250px] xl:h-[350px] 2xl:h-[400px] 5xl:border-secondary object-cover"
  src={img2}
  alt="pattu"
/>

          <div className="absolute bottom-7 left-1/2 transform text-center -translate-x-1/2  bg-[#000] bg-opacity-5 bg-[linear-gradient(179.61deg,_rgba(255,255,255,0)_-16.76%,_rgba(0,0,0,0.6)_0.33%)] w-full 5xl:w-[180px] 8xl:w-[200px] mb-4 py-1 text-primary font-bold font-abhaya text-md sm:text-lg 5xl:text-xl 7xl:text-2xl">
            PATTU MALAI
          </div>
        </div>
      </div>
      <div className="hidden 5xl:block">
        <h1 className="text-center mt-10 text-lg md:text-2xl 2xl:text-3xl 4xl:text-4xl 8xl:text-5xl 9xl:text-6xl 10xl:text-7xl 11xl:text-8xl font-semibold mb-2">
          We Are Selling
        </h1>
        <h2 className="font-abhaya text-md md:text-xl 2xl:text-2xl 8xl:text-3xl text-center font-bold text-secondary">
          PATTU MALAI
        </h2>
    </div>
    </div>
  );
};

export default Malai;
